module.exports = __webpack_public_path__ + "static/media/Farmacia.f35a81bf.jpg";